import React from "react";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

const BookingInfo = ({ house }) => {
    return (
        <div className="mt-12 overflow-hidden rounded-2xl bg-slate-950 p-8 text-center shadow-[0_24px_80px_rgba(15,23,42,0.2)]">
            <div className="mx-auto max-w-2xl">
            <h3 className="text-2xl font-bold text-white mb-3">Ready to Book Your Stay?</h3>
            <p className="text-lg text-white/70 mb-6">
                Contact us to reserve your perfect beach getaway
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a 
                    href={`tel:${house.agent.phone}`}
                    className="flex items-center gap-3 rounded-xl bg-white px-6 py-3 font-semibold text-slate-950 shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#f7c45f]"
                >
                    <BsTelephoneFill className="text-xl" />
                    <span>{house.agent.phone}</span>
                </a>
                <a 
                    href={`sms:${house.agent.phone}`}
                    className="flex items-center gap-3 rounded-xl border border-white/20 bg-white/10 px-6 py-3 font-semibold text-white shadow-lg backdrop-blur transition-all duration-300 hover:-translate-y-0.5 hover:bg-teal-700"
                >
                    <MdEmail className="text-xl" />
                    <span>Send Text Message</span>
                </a>
            </div>
            </div>
        </div>
    );
};

export default BookingInfo;
